import { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [msg, setMsg] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async e => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      const { data } = await api.post('/auth/forgot-password', { email });
      setMsg(data.message);
    } catch { setError('Something went wrong. Try again.'); }
    finally { setLoading(false); }
  };

  const s = {
    wrap: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f5f7' },
    card: { background: '#fff', borderRadius: 12, padding: '40px 36px', width: 360, boxShadow: '0 2px 16px rgba(0,0,0,0.08)' },
    title: { fontSize: 18, fontWeight: 600, marginBottom: 8 },
    sub: { fontSize: 13, color: '#888', marginBottom: 24 },
    input: { width: '100%', padding: '9px 12px', border: '1px solid #ddd', borderRadius: 8, fontSize: 14, marginBottom: 16, boxSizing: 'border-box' },
    btn: { width: '100%', padding: 10, background: '#534AB7', color: '#fff', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 500, cursor: 'pointer' },
    link: { display: 'block', textAlign: 'center', marginTop: 16, fontSize: 13, color: '#534AB7', textDecoration: 'none' },
    success: { background: '#EAF3DE', color: '#27500A', padding: '10px 12px', borderRadius: 8, fontSize: 13, marginBottom: 16 },
    error: { background: '#FCEBEB', color: '#791F1F', padding: '10px 12px', borderRadius: 8, fontSize: 13, marginBottom: 16 },
  };

  return (
    <div style={s.wrap}>
      <div style={s.card}>
        <div style={s.title}>Reset password</div>
        <p style={s.sub}>Enter your email and we'll send a reset link.</p>
        {msg && <div style={s.success}>{msg}</div>}
        {error && <div style={s.error}>{error}</div>}
        {!msg && (
          <form onSubmit={submit}>
            <input style={s.input} type="email" placeholder="your@email.com"
              value={email} onChange={e => setEmail(e.target.value)} required />
            <button style={s.btn} type="submit" disabled={loading}>{loading ? 'Sending...' : 'Send reset link'}</button>
          </form>
        )}
        <Link to="/login" style={s.link}>Back to login</Link>
      </div>
    </div>
  );
}
